import FragmentApp from 'renderer/FragmentApp';
import { getRootData, hydrateClient } from 'client/shared/hydrateClient';

export const renderFragmentClient = () => {
  // Ensure window.dataLayer exists so Fragments can safely push to it.
  window.dataLayer = window.dataLayer || [];

  const rootData = getRootData();
  const { namespace, content, config } = rootData;
  const { componentData = [] } = content || {};

  return hydrateClient({
    loggerName: 'renderFragmentClient',
    appElement: (
      <FragmentApp
        componentLibraryConfig={{
          ...(config || {}),
          cfDomain: config?.cfDomain ?? '',
        }}
        componentData={componentData}
        contentPath={namespace ?? ''}
      />
    ),
    rootData,
  });
};
